/**
 *@file server-config.js
 *@version 1.0.1
 * @description   所有服务器的url配置
 */
const dirServicePath = '';
const dirServicePathNMDC = 'https://nmdc.cn/api';
// 服务数据
const serverUrl = {
  VisitsNumber: `${dirServicePathNMDC}/services/nmdcweb/api/subdomains/query/VisitsNumber/CLSGDB v2`
};
export default serverUrl;



// WEBPACK FOOTER //
// ./src/js/server-config.js